import React from 'react';
import PropTypes from 'prop-types';
import { getURL } from '~/server/formatters';
import { useAccount } from '../../../accountContext';

const UpgradePath = ({
  children,
  shouldShowUpgradeButton,
  shouldPickModalOnOrganizationState,
}) => {
  // Get user data from account query
  const user = useAccount();
  const { isOneBufferOrganization } = user?.account?.currentOrganization || {};

  const navigateToMigrationHub = (cta) => {
    const migrationHubURL = cta
      ? `${getURL.getMigrationHubURL()}?${cta}`
      : `${getURL.getMigrationHubURL()}`;

    window.location.assign(migrationHubURL);
  };

  if (!shouldShowUpgradeButton) return <span />;

  const onUpgradeClick = ({ cta, ctaMPMigration }) => {
    if (isOneBufferOrganization) {
      const { MODALS, actions } = window?.appshell || {};
      actions.openModal(MODALS.subscriptionUpdate, {
        cta,
        shouldPickModalOnOrganizationState,
      });
    } else {
      navigateToMigrationHub(ctaMPMigration);
    }
  };
  return <div>{children(onUpgradeClick)}</div>;
};

UpgradePath.propTypes = {
  children: PropTypes.func.isRequired,
  shouldShowUpgradeButton: PropTypes.bool,
  shouldPickModalOnOrganizationState: PropTypes.bool,
};

UpgradePath.defaultProps = {
  shouldShowUpgradeButton: false,
  shouldPickModalOnOrganizationState: false,
};

export default UpgradePath;
